import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import CheckEligibility from '../../services/check-eligibility.service';
import { AnalyticsService } from '../../services/analytics.service';
import { TooltipsService } from '../../services/tooltips.service';
import axios from 'axios';
import './product-offering-exchange.component.scss';
import * as $ from 'jquery';
import * as _ from 'lodash';
var ProductOfferingExchange = /** @class */ (function (_super) {
    tslib_1.__extends(ProductOfferingExchange, _super);
    function ProductOfferingExchange(element, analyticsService) {
        return _super.call(this, element) || this;
    }
    ProductOfferingExchange.prototype.init = function () {
        this.checkEligibility = new CheckEligibility();
        var storage = localStorage.getItem('comparison');
        var storageCurrency = localStorage.getItem('currency');
        var storageEligibility = localStorage.getItem('eligibility');
        this.endpoint = this.element.getAttribute('data-endpoint');
        this.productKey = this.element.getAttribute('data-productkey');
        this.productContainer = $('.product-card-wrapper');
        if (this.element.querySelector('.product-offering-exchange__currencies--items')) {
            this.currencyContainer = this.element.querySelector('.product-offering-exchange__currencies--items');
        }
        this.removeAll = $('.js-remove-all');
        this.producttype = this.element.getAttribute('data-producttype');
        if (this.producttype) {
            this.producttype = this.producttype.toLowerCase();
        }
        if (!storage) {
            storage = {};
            storage[this.productKey] = [];
            localStorage.setItem('comparison', JSON.stringify(storage));
        }
        else {
            storage = JSON.parse(storage);
            if (!storage[this.productKey]) {
                storage[this.productKey] = [];
                localStorage.setItem('comparison', JSON.stringify(storage));
            }
        }
        if (!storageCurrency) {
            storageCurrency = "";
            localStorage.setItem('currency', JSON.stringify(storageCurrency));
        }
        else {
            storageCurrency = JSON.parse(storageCurrency);
            if (!storageCurrency) {
                storageCurrency = "";
                localStorage.setItem('currency', JSON.stringify(storageCurrency));
            }
        }
        if (!storageEligibility) {
            storageEligibility = {};
            localStorage.setItem('eligibility', JSON.stringify(storageEligibility));
        }
        else {
            storageEligibility = JSON.parse(storageEligibility);
        }
        this.comparison = storage;
        this.currencyStorage = storageCurrency;
        this.eligibilityStorage = storageEligibility;
        if (typeof jsonData !== 'undefined') {
            this.getProducts();
        }
    };
    ProductOfferingExchange.prototype.bindEvents = function () {
        var _this = this;
        $(document).on('click', '.js-remove-compare', function (e) {
            var productId = $(e.currentTarget).data('id');
            if (_this.comparison[_this.productKey].find(function (item) { return item == productId; })) {
                var index = _this.comparison[_this.productKey].indexOf(productId);
                if (index >= 0) {
                    _this.comparison[_this.productKey].splice(index, 1);
                    localStorage.setItem('comparison', JSON.stringify(_this.comparison));
                    if (_this.comparison[_this.productKey].length >= 2) {
                        $('.js-compare-button').removeClass('button--disabled');
                    }
                    else {
                        $('.js-compare-button').addClass('button--disabled');
                    }
                    $(".form__control--checkbox input").removeAttr('disabled');
                    $(".product-card[data-id='" + productId + "'] .product-card__outer").removeClass("gradient-border");
                    $(".form__control--checkbox[data-id='" + productId + "'] input").prop('checked', false);
                    $(".product-offering-exchange__compare-chip[data-id='" + productId + "']").addClass('product-offering-exchange__compare-chip--hide');
                    setTimeout(function () {
                        $(".product-offering-exchange__compare-chip[data-id='" + productId + "']").remove();
                        if (!_this.productComparisonCheck()) {
                            $('.product-offering-exchange__compare').removeClass('product-offering-exchange__compare--active');
                        }
                    }, 300);
                }
            }
        });
        this.removeAll.click(function (e) {
            e.preventDefault();
            $(".product-card .product-card__outer").removeClass("gradient-border");
            $(".form__control--checkbox input").removeAttr('disabled');
            $(".form__control--checkbox input").prop('checked', false);
            $(".product-offering-exchange__compare-chip").addClass('product-offering-exchange__compare-chip--hide');
            setTimeout(function () {
                $(".product-offering-exchange__compare-chip").remove();
                // $(`.product-offering-exchange__compare-chip-padder`).remove();
                _this.comparison[_this.productKey] = [];
                localStorage.setItem('comparison', JSON.stringify(_this.comparison));
                $('.product-offering-exchange__compare').removeClass('product-offering-exchange__compare--active');
                $('.js-compare-button').removeClass('button--disabled');
            }, 300);
        });
        $(document).on('click', '.product-filter__item', function (e) {
            var filter = $(e.currentTarget).data('filter');
            _this.filterProducts(filter);
        });
        window.addEventListener('resize', this.debounce(function () {
            _this.normalizeCardHeight();
        }, 50, false));
        if (this.currencySelector) {
            this.currencySelector.map(function (item) { return item.addEventListener('click', function (event) {
                _this.currencySelector.forEach(function (element) {
                    element.classList.remove('product-offering-exchange__currencies--item__active');
                });
                _this.currencyClick(event);
            }); });
        }
        $(document).on('click', '.js-recheck-eligibility', function (e) {
            var element = e.target;
            _this.recheckEligibility(element);
        });
        // $(document).on('click', 'div.product-offering-exchange__button[data-buttonclass=Apply]', (e) => {
        // 	let element: any;
        // 	if(e.currentTarget){
        // 		element = e.currentTarget;
        // 	}else{
        // 		element = e.target;
        // 	}
        // 	let getAnchor = element.querySelector('a');
        // 	let getLeadId = getAnchor.getAttribute('data-leadid');
        // 	let getProductName = getAnchor.getAttribute('data-productname');
        // 	let getClosestParent = element.closest('.product-card__buttons');
        // 	let getEligibilityMessage = getClosestParent.querySelector('.product-offering-exchange__eligibility-message');
        // 	// APPLICATION ID
        // 	let valueProductID = $(element).closest('.js-product-id').attr('data-productid');
        // 	let valueEligibilityFormID = $(element).closest('.js-product-id').find('div[data-buttonclass=Eligibility]').find('.js-apply-now-modal-open').attr('data-modal');
        // 	console.log('Modal ID', valueEligibilityFormID);
        // 	console.log('Product ID', valueProductID);
        // 	this.checkEligibility.checkApplicationID(
        // 		valueEligibilityFormID, 
        // 		valueProductID
        // 	);
        // 	this.actionApplyNow(getLeadId, getProductName, getEligibilityMessage);
        // });
    };
    ProductOfferingExchange.prototype.animate = function () {
    };
    ProductOfferingExchange.prototype.getProducts = function () {
        var _this = this;
        var parseData = jsonData;
        this.currencies = parseData.currencies;
        this.filterJson = parseData.filters;
        this.productJson = parseData.products;
        this.comparable = _.some(this.productJson, function (product) {
            return product.comparable;
        });
        this.renderFilters();
        var docfragment = document.createDocumentFragment();
        var iCount = 1;
        this.productJson.forEach(function (card) {
            docfragment.appendChild(_this.renderProduct(card, iCount));
        });
        this.productContainer[0].appendChild(docfragment);
        TooltipsService.initTooltips();
        this.normalizeCardHeight();
        this.compareCard = $('.js-compare');
        this.compareCard.click(function (e) { return _this.compareClick(e); });
        //this.comparison = localStorage.getItem('comparison');
        if (this.comparison) {
            //this.comparison = JSON.parse(this.comparison);
            this.comparison[this.productKey].forEach(function (id) {
                $(".product-card[data-id='" + id + "'] .product-card__outer").addClass("gradient-border");
                $(".form__control--checkbox[data-id='" + id + "'] input").prop('checked', 'checked');
            });
            if (this.comparison[this.productKey].length >= 3) {
                $(".form__control--checkbox input").prop('disabled', 'disabled');
                this.comparison[this.productKey].forEach(function (id) {
                    $(".form__control--checkbox[data-id='" + id + "'] input").removeAttr('disabled');
                });
            }
            if (this.comparison[this.productKey].length > 0) {
                var hasComparedProducts = false;
                if (this.productComparisonCheck()) {
                    $('.product-offering-exchange__compare').addClass('product-offering-exchange__compare--active');
                    this.comparison[this.productKey].forEach(function (id) {
                        _this.renderComparisonChips(id);
                    });
                    // $('.product-offering-exchange__compare-chip-padder').remove();
                    // $('.product-offering-exchange__compare-chip-wrapper').append("<span class='product-offering-exchange__compare-chip-padder'>&nbsp;</span>");
                }
            }
            if (this.comparison[this.productKey].length >= 2) {
                $('.js-compare-button').removeClass('button--disabled');
            }
            else {
                $('.js-compare-button').addClass('button--disabled');
            }
        }
        this.renderCurrencyFilters(this.currencies);
    };
    ProductOfferingExchange.prototype.normalizeCardHeight = function () {
        if ($(window).width() < 951) {
            $('.product-card__content').css('min-height', "initial");
            $('.product-card__content > p').css('min-height', "initial");
            $('.product-card__terms').css('min-height', "initial");
        }
        else {
            var highestContent_1 = 0;
            $('.product-card__content').each(function (index, el) {
                var contentHeight = $(el).outerHeight();
                if (highestContent_1 < contentHeight) {
                    highestContent_1 = contentHeight;
                }
            });
            $('.product-card__content').css('min-height', highestContent_1 + "px");
            var highestParagragh_1 = 0;
            $('.product-card__content > p').each(function (index, el) {
                var paragraphHeight = $(el).height();
                if (highestParagragh_1 < paragraphHeight) {
                    highestParagragh_1 = paragraphHeight;
                }
            });
            $('.product-card__content > p').css('min-height', highestParagragh_1 + "px");
            var highestTerms_1 = 0;
            $('.product-card__terms').each(function (index, el) {
                var termHeight = $(el).height();
                if (highestTerms_1 < termHeight) {
                    highestTerms_1 = termHeight;
                }
            });
            $('.product-card__terms').css('min-height', highestTerms_1 + "px");
        }
        // let wrapper = this.element.querySelector('.product-card-wrapper');
        // wrapper.setAttribute('style',`min-height: ${wrapper.clientHeight}px`);
    };
    ProductOfferingExchange.prototype.compareClick = function (e) {
        var _this = this;
        var productId = $(e.currentTarget).parent().data('id');
        if (!this.comparison[this.productKey]) {
            this.comparison[this.productKey].push(productId);
            localStorage.setItem('comparison', JSON.stringify(this.comparison));
            this.renderComparisonChips(productId);
            $('.product-offering-exchange__compare').addClass('product-offering-exchange__compare--active');
            $('.js-compare-button').addClass('button--disabled');
        }
        else {
            if (this.comparison[this.productKey].find(function (item) { return item == productId; })) {
                var index = this.comparison[this.productKey].indexOf(productId);
                if (index >= 0) {
                    this.comparison[this.productKey].splice(index, 1);
                    localStorage.setItem('comparison', JSON.stringify(this.comparison));
                    $(".form__control--checkbox input").removeAttr('disabled');
                    $(".product-offering-exchange__compare-chip[data-id='" + productId + "']").remove();
                    $(".product-offering-exchange__compare-chip[data-id='" + productId + "']").addClass('product-offering-exchange__compare-chip--hide');
                    setTimeout(function () {
                        $(".product-offering-exchange__compare-chip[data-id='" + productId + "']").remove();
                        if (!_this.productComparisonCheck()) {
                            $('.product-offering-exchange__compare').removeClass('product-offering-exchange__compare--active');
                        }
                    }, 300);
                }
            }
            else if (this.comparison[this.productKey].length < 3) {
                this.comparison[this.productKey].push(productId);
                localStorage.setItem('comparison', JSON.stringify(this.comparison));
                // $('.product-offering-exchange__compare-chip-padder').remove();
                this.renderComparisonChips(productId);
                // $('.product-offering-exchange__compare-chip-wrapper').append("<span class='product-offering-exchange__compare-chip-padder'>&nbsp;</span>");
                if (this.comparison[this.productKey].length >= 3) {
                    $(".form__control--checkbox input").prop('disabled', 'disabled');
                    this.comparison[this.productKey].forEach(function (id) {
                        $(".form__control--checkbox[data-id='" + id + "'] input").removeAttr('disabled');
                    });
                }
            }
            if (this.productComparisonCheck()) {
                $('.product-offering-exchange__compare').addClass('product-offering-exchange__compare--active');
            }
            if (this.comparison[this.productKey].length >= 2) {
                $('.js-compare-button').removeClass('button--disabled');
            }
            else {
                $('.js-compare-button').addClass('button--disabled');
            }
        }
        if ($(".product-card[data-id='" + productId + "'] .product-card__outer").hasClass("gradient-border")) {
            $(".product-card[data-id='" + productId + "'] .product-card__outer").removeClass("gradient-border");
        }
        else {
            $(".product-card[data-id='" + productId + "'] .product-card__outer").addClass("gradient-border");
        }
    };
    ProductOfferingExchange.prototype.currencyClick = function (event) {
        var element = event.target;
        if (element !== undefined) {
            var currency_1 = element.getAttribute('data-currency');
            var productCards = Array.from(this.element.querySelectorAll('.product-card'));
            if (currency_1 == 'OTHER') {
                productCards.forEach(function (card) {
                    card.classList.add('d-none');
                    var supportedCurrencies = card.getAttribute('data-supportedcurrencies');
                    supportedCurrencies = supportedCurrencies.trim().split(' ').join('');
                    var splittedCurrencies = supportedCurrencies.split(',');
                    if (splittedCurrencies.length > 5) {
                        card.classList.remove('d-none');
                    }
                });
            }
            else {
                productCards.forEach(function (card) {
                    card.classList.add('d-none');
                    var supportedCurrencies = card.getAttribute('data-supportedcurrencies');
                    supportedCurrencies = supportedCurrencies.trim().split(' ').join('');
                    var splittedCurrencies = supportedCurrencies.split(',');
                    splittedCurrencies.forEach(function (currencySplitted) {
                        if (currencySplitted == currency_1) {
                            card.classList.remove('d-none');
                        }
                    });
                });
            }
            element.classList.add('product-offering-exchange__currencies--item__active');
            this.currencyStorage = currency_1;
            localStorage.setItem('currency', JSON.stringify(this.currencyStorage));
            this.renderCurrency(currency_1);
        }
    };
    ProductOfferingExchange.prototype.productComparisonCheck = function () {
        var _this = this;
        //checks to see if the products from JSON match anything in the local storage
        return _.some(this.comparison[this.productKey], function (el) {
            return _.includes(_.map(_this.productJson, function (prod) { return prod.id; }), el);
        });
    };
    ProductOfferingExchange.prototype.renderCurrencySelected = function () {
        var _this = this;
        this.currencySelector.map(function (element) {
            var currency = element.getAttribute('data-currency');
            if (currency == _this.currencyStorage) {
                element.classList.add('product-offering-exchange__currencies--item__active');
                _this.renderCurrency(_this.currencyStorage);
            }
        });
    };
    ProductOfferingExchange.prototype.renderProduct = function (input, orderIndex) {
        var _this = this;
        // VARIABLES
        var productPrices = "";
        var productTags = "";
        var productTerms = "";
        var productButtons = "";
        var productSupportedCurrencies = "";
        var pricingCurrencies = [];
        // FOR EACH PRICING
        var termCount = 0;
        var pricingArray = {};
        input.pricing.forEach(function (price) {
            var pricingKeyParent = price.subTitle;
            pricingKeyParent = pricingKeyParent.trim().split(' ').join('').toLowerCase();
            pricingArray[pricingKeyParent] = {};
            pricingArray[pricingKeyParent].title = price.subTitle;
            pricingArray[pricingKeyParent].items = [];
            var items = pricingArray[pricingKeyParent].items;
            if (pricingKeyParent == "supportedcurrencies") {
                productSupportedCurrencies = price.title;
            }
            input.pricing.forEach(function (price) {
                var pricingKey = price.subTitle;
                pricingKey = pricingKey.trim().split(' ').join('').toLowerCase();
                if (pricingKeyParent == pricingKey) {
                    items.push(price);
                }
            });
        });
        for (var key_1 in pricingArray) {
            var object = pricingArray[key_1];
            var items = object.items;
            var pricingSections = [];
            items.sort(this.dynamicSort);
            items.forEach(function (element) {
                var orderKey = element.order;
                if (element.terms) {
                    if (element.symbol) {
                        pricingCurrencies.push(element.symbol);
                    }
                    var result = _.entries(_.countBy(pricingCurrencies)).map(function (_a) {
                        var name = _a[0], count = _a[1];
                        return ({ name: name, count: count });
                    });
                    result.forEach(function (item) {
                        if (item.name === element.symbol) {
                            termCount = item.count;
                        }
                    });
                    if (element.symbol === undefined) {
                        termCount = termCount + 1;
                    }
                    // termCount++;
                    var asterix = '';
                    for (var index = 0; index < termCount; index++) {
                        asterix += '*';
                    }
                    if (orderKey) {
                        if (orderKey > 1) {
                            productTerms += "\n\t\t\t\t\t\t\t\t<div class=\"product-offering-exchange__terms product-offering-exchange__card--hidden\" data-currency-value=\"" + element.symbol + ("\">\n\t\t\t\t\t\t\t\t\t<span class=\"title title--asterisk\">" + asterix + "</span>\n\t\t\t\t\t\t\t\t\t<span>" + element.terms + "</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t");
                        }
                        else {
                            productTerms += "\n\t\t\t\t\t\t\t\t<div class=\"product-offering-exchange__terms\" data-currency-value=\"" + element.symbol + ("\">\n\t\t\t\t\t\t\t\t\t<span class=\"title title--asterisk\">" + asterix + "</span>\n\t\t\t\t\t\t\t\t\t<span>" + element.terms + "</span>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t");
                        }
                    }
                    else {
                        productTerms += "\n\t\t\t\t\t\t\t<div class=\"product-offering-exchange__terms\" data-currency-value=\"" + element.symbol + ("\">\n\t\t\t\t\t\t\t\t<span class=\"title title--asterisk\">" + asterix + "</span>\n\t\t\t\t\t\t\t\t<span>" + element.terms + "</span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t");
                    }
                }
                productPrices += _this.renderProductPrice(element, termCount, true);
            });
        }
        // FOR EACH BUTTON
        var btnCount = 0;
        var checkStorage = "";
        var storageValue = "";
        var productEligibility = "";
        var eligibilityExists = false;
        for (var key in this.eligibilityStorage) {
            var stripApplyNowModal = key.replace('apply-now-modal-', '');
            checkStorage = _.filter(input.buttons, { modalId: stripApplyNowModal });
            if (checkStorage.length > 0) {
                storageValue = this.eligibilityStorage[key];
                productEligibility = this.renderEligibleMessage(this.eligibilityStorage[key].result, key);
            }
        }
        input.buttons.forEach(function (element) {
            if (element.buttonClass == "Eligibility") {
                eligibilityExists = true;
            }
        });
        input.buttons.forEach(function (btn) {
            productButtons += _this.renderButtons(btn, btnCount, input, storageValue, eligibilityExists);
            btnCount++;
        });
        productTerms = "\n\t\t\t<div class=\"product-card__terms\">\n\n\t\t\t\t" + productTerms + "\n\n\t\t\t</div>";
        // FOR EACH TAG
        input.tags.forEach(function (tag) {
            productTags += " " + tag.replace(/ /g, "-");
        });
        var output = "";
        output += "<div class=\"product-card product-card__image js-product-id " + productTags.toLowerCase() + "\" data-productid=\"" + input.id + "\" data-id=\"" + input.id + "\" style=\"order: " + orderIndex + ";\" data-supportedcurrencies=\"" + productSupportedCurrencies + "\">";
        if (input.onPromotion) {
            output += "<div class=\"product-card__feature-badge feature-badge\">\n\t\t\t\t" + input.promotionLabel + "\n\t\t\t</div>";
        }
        if (input.cardImage) {
            output += "<img class=\"product-card__image--card\" src=\"" + input.cardImage + "\">";
        }
        output += "\n\t\t<div class=\"product-card__outer\">\n\t\t\t<div class=\"product-card__inner\" data-trackingregion=\"product offering " + this.producttype + (" > " + input.title.toLowerCase() + "\">\n\t\t\t\t<div class=\"product-card__content\">\n\t\t\t\t\t<h4 class=\"title title--module-sub-title product-card__title\">\n\t\t\t\t\t\t" + input.title + "\n\t\t\t\t\t</h4>\n\t\t\t\t\t<div class=\"title title-gradient title-gradient--product\"></div>\n\t\t\t\t\t<p>" + input.subTitle + "</p>\n\t\t\t\t\t<div class=\"row\">\n\t\t\t\t\t\t" + productPrices + "\n\t\t\t\t\t</div>\n\t\t\t\t</div>");
        //card buttons
        output += "\n\t\t\t<div class=\"product-card__buttons\">\n\n\t\t\t\t<div class=\"row\">\n\n\t\t\t\t\t<div class=\"col-12\">\n\n\t\t\t\t\t\t" + productTerms + "\n\n\t\t\t\t\t\t<div class=\"float-md-right float-sm-left\">\n\n\t\t";
        if (input.comparable) {
            if (input.comparable === "true") {
                output += "\n\t\t\t\t\t\t\t\t<label data-id=\"" + input.id + "\" class=\"form__control form__control--checkbox\">\n\t\n\t\t\t\t\t\t\t\t\tAdd to compare\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" class=\"js-compare\">\n\t\t\t\t\t\t\t\t\t<div class=\"form__control-indicator\"></div>\n\t\n\t\t\t\t\t\t\t\t</label>\n\t\t\t\t";
            }
            else {
                output += "\n\t\t\t\t\t\t\t\t<div class=\"" + (this.comparable ? 'product-card__compare-placeholder' : 'product-card__compare-placeholder product-card__compare-placeholder--sml') + "\"></div>\n\t\t\t\t";
            }
        }
        else {
            output += "\n\t\t\t\t\t\t\t<div class=\"" + (this.comparable ? 'product-card__compare-placeholder' : 'product-card__compare-placeholder product-card__compare-placeholder--sml') + "\"></div>\n\t\t\t";
        }
        output += "\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t<div class=\"product-offering-exchange__eligibility\">" + productEligibility + "</div>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t\t" + productButtons + "\n\n\t\t\t\t</div>\n\n\t\t\t</div>";
        //end card buttons
        output += "</div>"; //inner close
        output += "</div>"; //outer close
        output += "</div>"; //main close
        return document.createRange().createContextualFragment(output);
    };
    ProductOfferingExchange.prototype.renderButtons = function (input, index, product, storage, eligibility) {
        if (storage === void 0) { storage = {}; }
        if (eligibility === void 0) { eligibility = false; }
        var output = "";
        var productTitle = product.title ? product.title : "<<product name>>";
        var dataIntent = 'Informational';
        var dataClass = 'button--main';
        if (input.buttonClass) {
            var dataButtonClass = input.buttonClass.toLowerCase();
            if (dataButtonClass === 'eligibility') {
                dataIntent = 'Transactional';
                dataClass = 'button--main';
            }
            else if (dataButtonClass === 'callmeback') {
                dataIntent = 'Query';
                dataClass = 'button--main';
            }
            else if (dataButtonClass === 'apply') {
                dataIntent = 'Transactional';
                dataClass = 'button--main';
            }
            else if (dataButtonClass === 'applywhitebutton') {
                dataIntent = 'Transactional';
                dataClass = 'button--white button--border-blue';
            }
            else if (dataButtonClass === 'contactus') {
                dataIntent = 'Query';
                dataClass = 'button--white button--border-blue';
            }
            else if (dataButtonClass === 'contact us') {
                dataIntent = 'Query';
                dataClass = 'button--white button--border-blue';
            }
            else if (dataButtonClass === 'contact') {
                dataIntent = 'Query';
                dataClass = 'button--white button--border-blue';
            }
            else if (dataButtonClass === 'productdetails') {
                dataIntent = 'Informational';
                dataClass = 'button--white button--border-blue';
            }
            else if (dataButtonClass === 'compare') {
                dataIntent = 'Comparison;';
                dataClass = 'button--white button--border-blue';
            }
            else if (dataButtonClass === 'salesforceapplynow') {
                dataIntent = 'Transactional';
                dataClass = 'button--main';
            }
            else {
                dataClass = 'button--white button--border-blue';
            }
        }
        if (storage.result == "apply") {
            if (input.buttonClass == 'Apply' || input.buttonClass == 'ProductDetails') {
                if (input.isModal) {
                    output += "<div class=\"" + (index === 0 ? 'product-card__button-wrap' : '') + " product-offering-exchange__button col-xs-6 col-sm-6\" data-buttonclass=\"" + input.buttonClass + "\">";
                    output += "<a class=\"button " + dataClass + " js-apply-now-modal-open\" href=\"javascript:void(0)\" target=\"\" data-productname=\"" + product.title + "\" data-modal=\"apply-now-modal-" + input.modalId + "\" data-intent=\"" + dataIntent + "\" data-scope=\"productOfferingExchange\" data-id=\"link_content_product offering\" data-text=\"" + this.producttype + " | " + productTitle + (" | " + input.title + " button click\" data-leadid=\"" + storage.leadID + "\">");
                    output += "" + input.title;
                    output += "</a>";
                    output += "</div>";
                }
                else {
                    if (input.buttonClass === 'Apply') {
                        output += "<div class=\"" + (index === 0 ? 'product-card__button-wrap' : '') + " product-offering-exchange__button col-xs-6 col-sm-6\" data-buttonclass=\"" + input.buttonClass + "\">";
                        output += "<a class=\"button " + dataClass + "\" href=\"javascript:void(0)\" data-productname=\"" + product.title + "\" target=\"" + input.target + "\" data-intent=\"" + dataIntent + "\" data-scope=\"productOfferingExchange\" data-id=\"link_content_product offering\" data-text=\"" + this.producttype + " | " + productTitle + (" | " + input.title + " button click\" data-leadid=\"" + storage.leadID + "\">");
                        output += "" + input.title;
                        output += "</a>";
                        output += "</div>";
                    }
                    else {
                        output += "<div class=\"" + (index === 0 ? 'product-card__button-wrap' : '') + " product-offering-exchange__button col-xs-6 col-sm-6\" data-buttonclass=\"" + input.buttonClass + "\">";
                        output += "<a class=\"button " + dataClass + "\" data-productname=\"" + product.title + "\" href=\"" + input.url + "\" target=\"" + input.target + "\" data-intent=\"" + dataIntent + "\" data-scope=\"productOfferingExchange\" data-id=\"link_content_product offering\" data-text=\"" + this.producttype + " | " + productTitle + (" | " + input.title + " button click\">");
                        output += "" + input.title;
                        output += "</a>";
                        output += "</div>";
                    }
                }
            }
            else {
                if (input.isModal) {
                    output += "<div class=\"" + (index === 0 ? 'product-card__button-wrap' : '') + " product-offering-exchange__button col-xs-6 col-sm-6 d-none\" data-buttonclass=\"" + input.buttonClass + "\">";
                    output += "<a class=\"button " + dataClass + " js-apply-now-modal-open\" href=\"javascript:void(0)\" target=\"\" data-productname=\"" + product.title + "\" data-modal=\"apply-now-modal-" + input.modalId + "\" data-intent=\"" + dataIntent + "\" data-scope=\"productOfferingExchange\" data-id=\"link_content_product offering\" data-text=\"" + this.producttype + " | " + productTitle + (" | " + input.title + " button click\">");
                    output += "" + input.title;
                    output += "</a>";
                    output += "</div>";
                }
                else {
                    output += "<div class=\"" + (index === 0 ? 'product-card__button-wrap' : '') + " product-offering-exchange__button col-xs-6 col-sm-6 d-none\" data-buttonclass=\"" + input.buttonClass + "\">";
                    output += "<a class=\"button " + dataClass + "\" href=\"" + input.url + "\" target=\"" + input.target + "\" data-productname=\"" + product.title + "\" data-intent=\"" + dataIntent + "\" data-scope=\"productOfferingExchange\" data-id=\"link_content_product offering\" data-text=\"" + this.producttype + " | " + productTitle + (" | " + input.title + " button click\">");
                    output += "" + input.title;
                    output += "</a>";
                    output += "</div>";
                }
            }
        }
        else if (storage.result == "callmeback") {
            if (input.buttonClass == 'CallMeBack' || input.buttonClass == 'ProductDetails') {
                if (input.isModal) {
                    output += "<div class=\"" + (index === 0 ? 'product-card__button-wrap' : '') + " product-offering-exchange__button col-xs-6 col-sm-6\" data-buttonclass=\"" + input.buttonClass + "\">";
                    output += "<a class=\"button " + dataClass + " js-apply-now-modal-open\" href=\"javascript:void(0)\" target=\"\" data-productname=\"" + product.title + "\" data-modal=\"apply-now-modal-" + input.modalId + "\" data-intent=\"" + dataIntent + "\" data-scope=\"productOfferingExchange\" data-id=\"link_content_product offering\" data-text=\"" + this.producttype + " | " + productTitle + (" | " + input.title + " button click\" data-leadid=\"" + storage.leadID + "\">");
                    output += "" + input.title;
                    output += "</a>";
                    output += "</div>";
                }
                else {
                    output += "<div class=\"" + (index === 0 ? 'product-card__button-wrap' : '') + " product-offering-exchange__button col-xs-6 col-sm-6\" data-buttonclass=\"" + input.buttonClass + "\">";
                    output += "<a class=\"button " + dataClass + "\" href=\"" + input.url + "\" target=\"" + input.target + "\" data-intent=\"" + dataIntent + "\" data-scope=\"productOfferingExchange\" data-id=\"link_content_product offering\" data-text=\"" + this.producttype + " | " + productTitle + (" | " + input.title + " button click\">");
                    output += "" + input.title;
                    output += "</a>";
                    output += "</div>";
                }
            }
            else {
                if (input.isModal) {
                    output += "<div class=\"" + (index === 0 ? 'product-card__button-wrap' : '') + " product-offering-exchange__button col-xs-6 col-sm-6 d-none\" data-buttonclass=\"" + input.buttonClass + "\">";
                    output += "<a class=\"button " + dataClass + " js-apply-now-modal-open\" href=\"javascript:void(0)\" target=\"\" data-productname=\"" + product.title + "\" data-modal=\"apply-now-modal-" + input.modalId + "\" data-intent=\"" + dataIntent + "\" data-scope=\"productOfferingExchange\" data-id=\"link_content_product offering\" data-text=\"" + this.producttype + " | " + productTitle + (" | " + input.title + " button click\" data-leadid=\"" + storage.leadID + "\">");
                    output += "" + input.title;
                    output += "</a>";
                    output += "</div>";
                }
                else {
                    output += "<div class=\"" + (index === 0 ? 'product-card__button-wrap' : '') + " product-offering-exchange__button col-xs-6 col-sm-6 d-none\" data-buttonclass=\"" + input.buttonClass + "\">";
                    output += "<a class=\"button " + dataClass + "\" href=\"" + input.url + "\" target=\"" + input.target + "\" data-intent=\"" + dataIntent + "\" data-scope=\"productOfferingExchange\" data-id=\"link_content_product offering\" data-text=\"" + this.producttype + " | " + productTitle + (" | " + input.title + " button click\">");
                    output += "" + input.title;
                    output += "</a>";
                    output += "</div>";
                }
            }
        }
        else if (storage.result == "contactus") {
            if (input.buttonClass == 'ContactUs' || input.buttonClass == 'ProductDetails') {
                if (input.isModal) {
                    output += "<div class=\"" + (index === 0 ? 'product-card__button-wrap' : '') + " product-offering-exchange__button col-xs-6 col-sm-6\" data-buttonclass=\"" + input.buttonClass + "\">";
                    output += "<a class=\"button " + dataClass + " js-apply-now-modal-open\" href=\"javascript:void(0)\" target=\"\" data-productname=\"" + product.title + "\" data-modal=\"apply-now-modal-" + input.modalId + "\" data-intent=\"" + dataIntent + "\" data-scope=\"productOfferingExchange\" data-id=\"link_content_product offering\" data-text=\"" + this.producttype + " | " + productTitle + (" | " + input.title + " button click\">");
                    output += "" + input.title;
                    output += "</a>";
                    output += "</div>";
                }
                else {
                    output += "<div class=\"" + (index === 0 ? 'product-card__button-wrap' : '') + " product-offering-exchange__button col-xs-6 col-sm-6\" data-buttonclass=\"" + input.buttonClass + "\">";
                    output += "<a class=\"button " + dataClass + "\" href=\"" + input.url + "\" target=\"" + input.target + "\" data-intent=\"" + dataIntent + "\" data-scope=\"productOfferingExchange\" data-id=\"link_content_product offering\" data-text=\"" + this.producttype + " | " + productTitle + (" | " + input.title + " button click\">");
                    output += "" + input.title;
                    output += "</a>";
                    output += "</div>";
                }
            }
            else {
                if (input.isModal) {
                    output += "<div class=\"" + (index === 0 ? 'product-card__button-wrap' : '') + " product-offering-exchange__button col-xs-6 col-sm-6 d-none\" data-buttonclass=\"" + input.buttonClass + "\">";
                    output += "<a class=\"button " + dataClass + " js-apply-now-modal-open\" href=\"javascript:void(0)\" target=\"\" data-productname=\"" + product.title + "\" data-modal=\"apply-now-modal-" + input.modalId + "\" data-intent=\"" + dataIntent + "\" data-scope=\"productOfferingExchange\" data-id=\"link_content_product offering\" data-text=\"" + this.producttype + " | " + productTitle + (" | " + input.title + " button click\">");
                    output += "" + input.title;
                    output += "</a>";
                    output += "</div>";
                }
                else {
                    output += "<div class=\"" + (index === 0 ? 'product-card__button-wrap' : '') + " product-offering-exchange__button col-xs-6 col-sm-6 d-none\" data-buttonclass=\"" + input.buttonClass + "\">";
                    output += "<a class=\"button " + dataClass + "\" href=\"" + input.url + "\" target=\"" + input.target + "\" data-intent=\"" + dataIntent + "\" data-scope=\"productOfferingExchange\" data-id=\"link_content_product offering\" data-text=\"" + this.producttype + " | " + productTitle + (" | " + input.title + " button click\">");
                    output += "" + input.title;
                    output += "</a>";
                    output += "</div>";
                }
            }
        }
        else {
            if (eligibility) {
                if (input.buttonClass == 'Eligibility' || input.buttonClass == 'ProductDetails') {
                    if (input.isModal) {
                        output += "<div class=\"" + (index === 0 ? 'product-card__button-wrap' : '') + " product-offering-exchange__button col-xs-6 col-sm-6\" data-buttonclass=\"" + input.buttonClass + "\">";
                        output += "<a class=\"button " + dataClass + " js-apply-now-modal-open\" href=\"javascript:void(0)\" target=\"\" data-productname=\"" + product.title + "\" data-modal=\"apply-now-modal-" + input.modalId + "\" data-intent=\"" + dataIntent + "\" data-scope=\"productOfferingExchange\" data-id=\"link_content_product offering\" data-text=\"" + this.producttype + " | " + productTitle + (" | " + input.title + " button click\">");
                        output += "" + input.title;
                        output += "</a>";
                        output += "</div>";
                    }
                    else {
                        output += "<div class=\"" + (index === 0 ? 'product-card__button-wrap' : '') + " product-offering-exchange__button col-xs-6 col-sm-6\" data-buttonclass=\"" + input.buttonClass + "\">";
                        output += "<a class=\"button " + dataClass + "\" data-productname=\"" + product.title + "\" href=\"" + input.url + "\" target=\"" + input.target + "\" data-intent=\"" + dataIntent + "\" data-scope=\"productOfferingExchange\" data-id=\"link_content_product offering\" data-text=\"" + this.producttype + " | " + productTitle + (" | " + input.title + " button click\">");
                        output += "" + input.title;
                        output += "</a>";
                        output += "</div>";
                    }
                }
                else {
                    if (input.isModal) {
                        output += "<div class=\"" + (index === 0 ? 'product-card__button-wrap' : '') + " product-offering-exchange__button col-xs-6 col-sm-6 d-none\" data-buttonclass=\"" + input.buttonClass + "\">";
                        output += "<a class=\"button " + dataClass + " js-apply-now-modal-open\" href=\"javascript:void(0)\" target=\"\" data-productname=\"" + product.title + "\" data-modal=\"apply-now-modal-" + input.modalId + "\" data-intent=\"" + dataIntent + "\" data-scope=\"productOfferingExchange\" data-id=\"link_content_product offering\" data-text=\"" + this.producttype + " | " + productTitle + (" | " + input.title + " button click\">");
                        output += "" + input.title;
                        output += "</a>";
                        output += "</div>";
                    }
                    else {
                        output += "<div class=\"" + (index === 0 ? 'product-card__button-wrap' : '') + " product-offering-exchange__button product-offering-exchange__button col-xs-6 col-sm-6 d-none\" data-buttonclass=\"" + input.buttonClass + "\">";
                        output += "<a class=\"button " + dataClass + "\" data-productname=\"" + product.title + "\" href=\"" + input.url + "\" target=\"" + input.target + "\" data-intent=\"" + dataIntent + "\" data-scope=\"productOfferingExchange\" data-id=\"link_content_product offering\" data-text=\"" + this.producttype + " | " + productTitle + (" | " + input.title + " button click\">");
                        output += "" + input.title;
                        output += "</a>";
                        output += "</div>";
                    }
                }
            }
            else {
                if (input.isModal) {
                    output += "<div class=\"" + (index === 0 ? 'product-card__button-wrap' : '') + " product-offering-exchange__button col-xs-6 col-sm-6\" data-buttonclass=\"" + input.buttonClass + "\">";
                    output += "<a class=\"button " + dataClass + " js-apply-now-modal-open\" href=\"javascript:void(0)\" target=\"\" data-productname=\"" + product.title + "\" data-modal=\"apply-now-modal-" + input.modalId + "\" data-intent=\"" + dataIntent + "\" data-scope=\"productOfferingExchange\" data-id=\"link_content_product offering\" data-text=\"" + this.producttype + " | " + productTitle + (" | " + input.title + " button click\">");
                    output += "" + input.title;
                    output += "</a>";
                    output += "</div>";
                }
                else {
                    output += "<div class=\"" + (index === 0 ? 'product-card__button-wrap' : '') + " product-offering-exchange__button col-xs-6 col-sm-6\" data-buttonclass=\"" + input.buttonClass + "\">";
                    output += "<a class=\"button " + dataClass + "\" data-productname=\"" + product.title + "\" href=\"" + input.url + "\" target=\"" + input.target + "\" data-intent=\"" + dataIntent + "\" data-scope=\"productOfferingExchange\" data-id=\"link_content_product offering\" data-text=\"" + this.producttype + " | " + productTitle + (" | " + input.title + " button click\">");
                    output += "" + input.title;
                    output += "</a>";
                    output += "</div>";
                }
            }
        }
        return output;
    };
    ProductOfferingExchange.prototype.renderProductPrice = function (input, termCount, hidden) {
        if (hidden === void 0) { hidden = false; }
        var output = "";
        if (hidden) {
            if (input.symbol === "GBP" || input.symbol === undefined) {
                output += "<div class=\"product-card__price col-6 col-xs-6 col-sm-6\" data-currency-value=\"" + input.symbol + "\">";
            }
            else {
                output += "<div class=\"product-card__price product-offering-exchange__card--hidden col-6 col-xs-6 col-sm-6\" data-currency-value=\"" + input.symbol + "\">";
            }
        }
        else {
            output += "<div class=\"product-card__price col-6 col-xs-6 col-sm-6\" data-currency-value=\"" + input.symbol + "\">";
        }
        output += this.renderProductSymbol(input);
        output += this.renderProductTitle(input, termCount);
        output += this.renderProductTooltip(input);
        // output += this.renderProductTerms(input, termCount);
        if (input.strike) {
            output += "\n\t\t\t\t<div class=\"title title--initial title--number-strike\">\n\t\t\t\t\t<span class=\"title title--number-striker\"></span>\n\t\t\t";
            if (input.symbolHidden !== "true") {
                if (input.symbol) {
                    var currencySymbol = this.symbol(input.symbol);
                    output += "\n\t\t\t\t\t\t<span class=\"title title--initial title--currency-sml\">\n\t\t\t\t\t\t\t" + currencySymbol.symbol + "\n\t\t\t\t\t\t</span>\n\t\t\t\t\t";
                }
            }
            output += "\n\t\t\t\t\t<span class=\"title title--initial title--number-sml\">\n\t\t\t\t\t\t" + input.strike + "\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t";
        }
        output += "\n\t\t\t<div class=\"title title--notes\">\n\t\t\t\t" + input.subTitle + "\n\t\t\t</div>\n\t\t";
        output += "</div>"; //main close
        return output;
    };
    ProductOfferingExchange.prototype.renderProductSymbol = function (input, termCount) {
        if (termCount === void 0) { termCount = 0; }
        var output = "";
        if (input.symbolHidden !== "true") {
            if (input.symbol && input.symbol.toLowerCase() == 'r') {
                var currencySymbol = this.symbol(input.symbol);
                output += "\n\t\t\t\t\t<span class=\"title title--initial title--currency\">\n\t\t\t\t\t\t" + currencySymbol.symbol + "\n\t\t\t\t\t</span>\n\t\t\t\t";
            }
            else {
                if (input.symbol) {
                    var currencySymbol = this.symbol(input.symbol);
                    output += "\n\t\t\t\t\t\t<span class=\"title title--initial title--currency\">\n\t\t\t\t\t\t\t" + currencySymbol.symbol + "\n\t\t\t\t\t\t</span>\n\t\t\t\t\t";
                }
            }
        }
        return output;
    };
    ProductOfferingExchange.prototype.renderProductTitle = function (input, termCountAsterix) {
        if (termCountAsterix === void 0) { termCountAsterix = 0; }
        var output = "";
        var termCount = input.title.length;
        if (input.note) {
            if (termCount <= 7) {
                output += "\n\t\t\t\t\t<span class=\"title title--initial product-card__price__note \">\n\t\t\t\t\t\t" + input.title + "\n\t\t\t\t\t</span>\n\t\t\t\t";
            }
            else if (termCount >= 8 && termCount < 16) {
                output += "\n\t\t\t\t\t<span class=\"title title--initial product-card__price__note\">\n\t\t\t\t\t\t" + input.title + "\n\t\t\t\t\t</span>\n\t\t\t\t";
            }
            else {
                output += "\n\t\t\t\t\t<span class=\"title title--initial product-card__price__note\">\n\t\t\t\t\t\t" + input.title + "\n\t\t\t\t\t</span>\n\t\t\t\t";
            }
        }
        else if (input.subTitle == "Supported currencies") {
            var supportedCurrencies = input.title.split(',');
            var supportedCurrenciesString = "";
            var supportedCurrenciesTooltip = "";
            if (supportedCurrencies.length <= 5) {
                for (var index = 0; index < supportedCurrencies.length; index++) {
                    if (index == 0) {
                        supportedCurrenciesString += supportedCurrencies[index];
                    }
                    else {
                        supportedCurrenciesString += ", " + supportedCurrencies[index];
                    }
                }
            }
            else if (supportedCurrencies.length > 5) {
                for (var index = 0; index < 5; index++) {
                    if (index == 0) {
                        supportedCurrenciesString += supportedCurrencies[index];
                    }
                    else {
                        supportedCurrenciesString += ", " + supportedCurrencies[index];
                    }
                }
                supportedCurrenciesString += ", Other";
                for (var index = 5; index < supportedCurrencies.length; index++) {
                    if (index == 5) {
                        supportedCurrenciesTooltip += "SUPPORTED CURRENCIES:<br>" + supportedCurrencies[index];
                    }
                    else {
                        supportedCurrenciesTooltip += ", " + supportedCurrencies[index];
                    }
                }
                supportedCurrenciesString += "\n\t\t\t\t<span title=\"" + supportedCurrenciesTooltip + "\" data-title=\"" + supportedCurrenciesTooltip + "\">\n\t\t\t\t\t<i data-component=\"icon\" data-icon=\"icon-tooltip\" class=\"icon \"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n\t\t\t\t\t\t<path fill=\"#0089FF\" fill-rule=\"evenodd\" d=\"M8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm-1-3h2v-2H7v2zm0-4.004h2V3H7v5.996z\"></path>\n\t\t\t\t\t</svg>\n\t\t\t\t\t</i>\n\t\t\t\t</span>\n\t\t\t\t";
            }
            output += "\n\t\t\t\t<span class=\"title title--initial title--number product-offering-exchange__pricing-title--small product-offering-exchange__pricing-title--supportedcurrencies\" style=\"display: flex !important;\">\n\t\t\t\t\t" + supportedCurrenciesString + "\n\t\t\t\t\t" + this.renderProductTermsSingle(input, termCountAsterix) + "\n\t\t\t\t</span>\n\t\t\t";
        }
        else {
            if (termCount <= 7) {
                output += "\n\t\t\t\t\t<span class=\"title title--initial title--number\">\n\t\t\t\t\t\t" + input.title + "\n\t\t\t\t\t\t" + this.renderProductTermsSingle(input, termCountAsterix) + "\n\t\t\t\t\t</span>\n\t\t\t\t";
            }
            else if (termCount >= 8 && termCount < 16) {
                output += "\n\t\t\t\t\t<span class=\"title title--initial title--number product-offering-exchange__pricing-title--medium\" style=\"display: flex !important;\">\n\t\t\t\t\t\t" + input.title + "\n\t\t\t\t\t\t" + this.renderProductTermsSingle(input, termCountAsterix) + "\n\t\t\t\t\t</span>\n\t\t\t\t";
            }
            else {
                output += "\n\t\t\t\t\t<span class=\"title title--initial title--number product-offering-exchange__pricing-title--small\" style=\"display: flex !important;\">\n\t\t\t\t\t\t" + input.title + "\n\t\t\t\t\t\t" + this.renderProductTermsSingle(input, termCountAsterix) + "\n\t\t\t\t\t</span>\n\t\t\t\t";
            }
        }
        return output;
    };
    ProductOfferingExchange.prototype.renderProductTooltip = function (input, termCount) {
        if (termCount === void 0) { termCount = 0; }
        var output = "";
        if (input.tooltip) {
            output += "\n\t\t\t\t<span title=\"" + input.tooltip + "\" data-title=\"" + input.tooltip + "\">\n\t\t\t\t\t<i data-component=\"icon\" data-icon=\"icon-tooltip\" class=\"icon \"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n\t\t\t\t\t\t<path fill=\"#0089FF\" fill-rule=\"evenodd\" d=\"M8 16c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8zm-1-3h2v-2H7v2zm0-4.004h2V3H7v5.996z\"></path>\n\t\t\t\t\t</svg>\n\t\t\t\t\t</i>\n\t\t\t\t</span>\n\t\t\t";
        }
        return output;
    };
    ProductOfferingExchange.prototype.renderProductTerms = function (input, termCount) {
        if (termCount === void 0) { termCount = 0; }
        var output = "";
        if (input.terms) {
            var asterix = '';
            for (var index = 0; index < termCount; index++) {
                asterix += '*';
            }
            output += "\n\t\t\t\t<span class=\"title title--initial title--asterisk\">" + asterix + "</span>\n\t\t\t";
        }
        return output;
    };
    ProductOfferingExchange.prototype.renderProductTermsSingle = function (input, termCount) {
        if (termCount === void 0) { termCount = 0; }
        var output = "";
        if (input.terms) {
            var asterix = '';
            for (var index = 0; index < termCount; index++) {
                asterix += '*';
            }
            output += "" + asterix;
        }
        return output;
    };
    ProductOfferingExchange.prototype.renderComparisonChips = function (id) {
        var item = this.productJson.find(function (item) { return item.id == id; });
        var output = "";
        output += "\n\t\t\t<span class=\"product-offering-exchange__compare-chip\" data-id=\"" + item.id + "\">\n\n\t\t\t\t<span class=\"title title--notes\">\n\n\t\t\t\t\t" + item.title + "\n\n\t\t\t\t</span>\n\n\t\t\t\t<i class=\"icon js-remove-compare\" data-id=\"" + item.id + "\">\n\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\">\n\t\t\t\t\t<g fill=\"none\" fill-rule=\"evenodd\">\n\t\t\t\t\t<circle cx=\"10\" cy=\"10\" r=\"10\" fill=\"#0089FF\"></circle>\n\t\t\t\t\t<path fill=\"#FFF\" d=\"M15 5.604L14.396 5 10 9.396 5.604 5 5 5.604 9.396 10 5 14.396l.604.604L10 10.604 14.396 15l.604-.604L10.604 10 15 5.604\"></path>\n\t\t\t\t\t</g>\n\t\t\t\t\t</svg>\n\t\t\t\t</i>\n\n\t\t\t</span>\n\t\t";
        var docfragment = document.createDocumentFragment();
        docfragment.appendChild(document.createRange().createContextualFragment(output));
        $('.product-offering-exchange__compare-chip-wrapper')[0].appendChild(docfragment);
        $('.product-offering-exchange__compare-chip-wrapper')[0].appendChild(docfragment);
    };
    ProductOfferingExchange.prototype.renderFilters = function () {
        if (this.filterJson && this.filterJson.length > 0) {
            $('.product-filter').addClass('product-filter--show');
            $('.product-filter').removeClass('product-filter--hide');
            var filterfragment_1 = document.createDocumentFragment();
            this.filterJson.forEach(function (filter) {
                filterfragment_1.appendChild(document.createRange().createContextualFragment("\n\t\t\t\t\t<span class=\"product-filter__item\"\n\t\t\t\t\tdata-filter=\"" + filter + "\" data-id=\"link_tab_tab\" data-text=\"product offering > " + filter.toLowerCase() + "\">\n\t\t\t\t\t\t" + filter + "\n\t\t\t\t\t</span>\n\t\t\t\t"));
            });
            document.querySelector('.product-filter__wrapper').appendChild(filterfragment_1);
        }
        else {
            if (this.filterJson) {
                $('.product-filter').addClass('product-filter--none');
                $('.product-filter').removeClass('product-filter--hide');
                $('.product-filter__placeholder > a').attr('src', this.element.getAttribute('data-filterurl'));
                $('.product-filter__placeholder .link__text').text(this.element.getAttribute('data-filtertext'));
            }
        }
    };
    ProductOfferingExchange.prototype.renderCurrency = function (currency) {
        var productCards = Array.from(this.element.querySelectorAll('.product-card'));
        var __productCardsAll = Array.from(this.element.querySelectorAll('.product-card__price'));
        var __productCardsAllTerms = Array.from(this.element.querySelectorAll('.product-offering-exchange__terms'));
        __productCardsAll.forEach(function (element) {
            element.classList.add('product-offering-exchange__card--hidden');
            if (element.getAttribute('data-currency-value') === currency || element.getAttribute('data-currency-value') === "undefined") {
                element.classList.remove('product-offering-exchange__card--hidden');
            }
        });
        __productCardsAllTerms.forEach(function (element) {
            element.classList.add('product-offering-exchange__card--hidden');
            if (element.getAttribute('data-currency-value') === currency || element.getAttribute('data-currency-value') === "undefined") {
                element.classList.remove('product-offering-exchange__card--hidden');
            }
        });
        if (currency == 'OTHER') {
            productCards.forEach(function (card) {
                card.classList.add('d-none');
                var supportedCurrencies = card.getAttribute('data-supportedcurrencies');
                supportedCurrencies = supportedCurrencies.trim().split(' ').join('');
                var splittedCurrencies = supportedCurrencies.split(',');
                if (splittedCurrencies.length > 5) {
                    card.classList.remove('d-none');
                }
            });
        }
        else {
            productCards.forEach(function (card) {
                card.classList.add('d-none');
                var supportedCurrencies = card.getAttribute('data-supportedcurrencies');
                supportedCurrencies = supportedCurrencies.trim().split(' ').join('');
                var splittedCurrencies = supportedCurrencies.split(',');
                splittedCurrencies.forEach(function (currencySplitted) {
                    if (currencySplitted == currency) {
                        card.classList.remove('d-none');
                    }
                });
            });
        }
    };
    ProductOfferingExchange.prototype.renderCurrencyFilters = function (currencies) {
        var _this = this;
        if (currencies) {
            currencies.forEach(function (currency) {
                if (_this.symbol(currency)) {
                    var currencyObject = _this.symbol(currency);
                    var currencyAnchor = document.createElement('a');
                    currencyAnchor.setAttribute('href', 'javascript:void(0)');
                    currencyAnchor.setAttribute('data-currency', currencyObject.symbolName);
                    currencyAnchor.style.backgroundImage = "url('" + currencyObject.image + "')";
                    currencyAnchor.classList.add('product-offering-exchange__currencies--item');
                    currencyAnchor.innerHTML = currencyObject.title;
                    _this.currencyContainer.appendChild(currencyAnchor);
                }
            });
        }
        this.currencySelector = Array.from(this.element.querySelectorAll('.product-offering-exchange__currencies--item'));
        this.currencySelector.map(function (element) {
            var currency = element.getAttribute('data-currency');
            if (currency == _this.currencyStorage[_this.productKey]) {
                element.classList.add('product-offering-exchange__currencies--item__active');
            }
        });
        this.normalizeCardHeight();
        this.renderCurrencySelected();
    };
    ProductOfferingExchange.prototype.renderEligibleMessage = function (result, modalId) {
        if (modalId === void 0) { modalId = ""; }
        var message = "";
        if (result) {
            if (result == "apply") {
                message += "<div class=\"product-offering-exchange__eligibility-message product-offering-exchange__eligibility-message--eligible\">";
                message += "You are eligible for this product.";
                message += "</div>";
            }
            else if (result == "callmeback") {
                message += "<div class=\"product-offering-exchange__eligibility-message product-offering-exchange__eligibility-message--eligible\">";
                message += "You are eligible for this product.";
                message += "</div>";
            }
            else {
                message += "<div class=\"product-offering-exchange__eligibility-message product-offering-exchange__eligibility-message--invalid\">";
                message += "You are not eligible for this product. <a href=\"javascript:;\" class=\"js-apply-now-modal-open js-recheck-eligibility\" data-modal=\"" + modalId + "\">Recheck</a>";
                message += "</div>";
            }
        }
        return message;
    };
    ProductOfferingExchange.prototype.recheckEligibility = function (element) {
        var _this = this;
        if (element) {
            var modalId_1 = element.getAttribute('data-modal');
            var getModalIdRechecks = Array.from(this.element.querySelectorAll('a.js-recheck-eligibility[data-modal=' + modalId_1 + ']'));
            getModalIdRechecks.forEach(function (button) {
                var closestMessageContainer = button.closest('.product-offering-exchange__eligibility');
                var closestButtonsContainer = button.closest('.product-card__buttons');
                var buttons = Array.from(closestButtonsContainer.querySelectorAll('.product-offering-exchange__button'));
                buttons.forEach(function (button) {
                    button.classList.add('d-none');
                    if (button.getAttribute('data-buttonclass') == "Eligibility" || button.getAttribute('data-buttonclass') == "ProductDetails") {
                        button.classList.remove('d-none');
                    }
                });
                closestMessageContainer.innerHTML = "";
                var storageEligibility = localStorage.getItem('eligibility');
                storageEligibility = JSON.parse(storageEligibility);
                _this.eligibilityStorage = storageEligibility;
                delete _this.eligibilityStorage[modalId_1];
                localStorage.setItem('eligibility', JSON.stringify(_this.eligibilityStorage));
            });
        }
    };
    ProductOfferingExchange.prototype.filterProducts = function (tag) {
        var _this = this;
        $(".product-card").addClass("product-card--hide");
        var filtered = this.productJson.filter(function (prod) {
            return prod.tags.indexOf(tag) > -1;
        });
        var removed = this.productJson.filter(function (prod) {
            return prod.tags.indexOf(tag) == -1;
        });
        setTimeout(function () {
            _this.productJson.forEach(function (el) {
                $(".product-card[data-id='" + el.id + "']").appendTo(".product-card-wrapper");
            });
            filtered.forEach(function (el) {
                $(".product-card[data-id='" + el.id + "']").removeClass("product-card--filtered").removeClass("product-card--hide");
            });
            removed.forEach(function (el) {
                $(".product-card[data-id='" + el.id + "']").addClass("product-card--filtered");
                $(".product-card[data-id='" + el.id + "']").appendTo(".product-card-wrapper");
            });
        }, 200);
    };
    ProductOfferingExchange.prototype.symbol = function (value) {
        var key = value;
        key = key.trim().split(' ').join('').toUpperCase();
        switch (key) {
            case "GBP":
                return {
                    title: "GBP",
                    symbolName: "GBP",
                    symbol: "£",
                    image: "/file_source/assets/icons/flag-united-kingdom.svg"
                };
                break;
            case "USD":
                return {
                    title: "USD",
                    symbolName: "USD",
                    symbol: "$",
                    image: "/file_source/assets/icons/flag-united-states.svg"
                };
                break;
            case "ZAR":
                return {
                    title: "ZAR",
                    symbolName: "ZAR",
                    symbol: "R",
                    image: "/file_source/assets/icons/flag-south-africa.svg"
                };
                break;
            case "AUD":
                return {
                    title: "AUD",
                    symbolName: "AUD",
                    symbol: "AU$",
                    image: "/file_source/assets/icons/flag-australia.svg"
                };
                break;
            case "EUR":
                return {
                    title: "EURO",
                    symbolName: "EUR",
                    symbol: "€",
                    image: "/file_source/assets/icons/flag-euro.svg"
                };
                break;
            case "OTHER":
                return {
                    title: "OTHER",
                    symbolName: "OTHER",
                    symbol: "",
                    image: "/file_source/assets/icons/flag-global.svg"
                };
                break;
            case "Other":
                return {
                    title: "OTHER",
                    symbolName: "OTHER",
                    symbol: "",
                    image: "/file_source/assets/icons/flag-global.svg"
                };
                break;
            case "other":
                return {
                    title: "OTHER",
                    symbolName: "OTHER",
                    symbol: "",
                    image: "/file_source/assets/icons/flag-global.svg"
                };
                break;
            default:
                break;
        }
    };
    ProductOfferingExchange.prototype.dynamicSort = function (a, b) {
        // Use toUpperCase() to ignore character casing
        var orderA = a.order;
        var orderB = b.order;
        var comparison = 0;
        if (orderA > orderB) {
            comparison = 1;
        }
        else if (orderA < orderB) {
            comparison = -1;
        }
        return comparison;
    };
    ProductOfferingExchange.prototype.debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate)
                    func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow)
                func.apply(context, args);
        };
    };
    ;
    ProductOfferingExchange.prototype.actionApplyNow = function (leadId, productName, messageEligibility) {
        if (leadId === void 0) { leadId = ''; }
        if (productName === void 0) { productName = ''; }
        var messageEligiblility = messageEligibility;
        var postData = '';
        postData += 'operation=submit&';
        postData += 'category=individual&';
        postData += 'leadID=' + leadId + '&';
        postData += 'productName=' + productName + '&';
        postData += 'appID=' + this.checkEligibility.applicationID + '&';
        postData += 'productID=' + this.checkEligibility.applicationProductID + '&';
        var analyticsService = new AnalyticsService();
        var url = "/services/SubmitWINLead.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            var json = response.data;
            if (json) {
                var errors = json.Errors;
                if (errors.length > 0) {
                    errors.forEach(function (error) {
                        analyticsService.dtmRecordSiteError('noerrorcode|' + error + '|' + url);
                        messageEligiblility.classList.add('product-offering-exchange__eligibility-message--invalid');
                        if (error.includes('Unknown product')) {
                            messageEligiblility.innerHTML = 'Invalid request';
                        }
                        if (error.includes('Authorization')) {
                            messageEligiblility.innerHTML = 'Invalid request';
                        }
                        if (error.includes('undocumented')) {
                            messageEligiblility.innerHTML = 'Request failed – try again later';
                        }
                        if (error.includes('existing')) {
                            messageEligiblility.innerHTML = 'Your request has already been submitted';
                        }
                    });
                }
                else {
                    var resources = json.Resources;
                    if (resources) {
                        var lmm = resources.LMM;
                        if (lmm) {
                            analyticsService.dtmFormComplete('complete', leadId);
                            window.location = lmm;
                        }
                    }
                }
            }
        }).catch(function (response) {
            analyticsService.dtmRecordSiteError('noerrorcode|' + response + '|' + url);
        });
    };
    return ProductOfferingExchange;
}(Base));
export { ProductOfferingExchange };



//////////////////
// WEBPACK FOOTER
// ./components/product-offering-exchange/product-offering-exchange.component.ts
// module id = 451
// module chunks = 0